export {
  isPolygonWithHoles,
  convertPolygonToMapPaths,
  getPolygonBoundaryCoords,
  getPolygonBoundaryCopy,
  convertTerritoryPolygonsToMapPaths,
  convertToLegacyPolygonFormat,
  convertPolygonToGeoJsonCoords,
  convertBoundaryGeometryToMapPaths,
  unionBoundaryGeometries,
} from './polygonUtils';
